import React, {useEffect, useState} from 'react';
import {Form, Header, Message, Segment, Table} from 'semantic-ui-react';
import {useLoaderData, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useMaskUtils from "../../../../shared/utils/hooks/useMaskUtils";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {EditClientRequest} from "../../../../models/requests/edit-client-request";

export async function editClientLoader({params}: any) {
    return params.id;
}

const EditClientsPage = () => {
    const [client, setClient] = useState<Partial<EditClientRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();
    const loader: any = useLoaderData();
    const {maskCnpj, unMask} = useMaskUtils();
    const blockUI = useBlockUI();
    const {getClientById, editClient} = useClientService();
    useEffect(() => {
        const clientId = loader;
        if (!clientId) return;

        getClientById(clientId).then((response: any) => {
            setClient(response)
        })
    }, [loader])
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    const updateClient = async () => {
        try {
            setLoading(true);
            if (client) {
                const result = await editClient({
                    ...client, cnpj: unMask(client.cnpj)
                }, client.id);
                if (!!result) {
                    navigate('/backoffice/clients/');
                    toast.success('Cliente atualizado com sucesso', ToasterConfig.success);
                }
            }
        } catch (error: any) {
            setLoading(false);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Clientes / Editar
            </Header>
            <Form size="large" onSubmit={updateClient}>
                <Segment stacked>
                    <Form.Input
                        fluid
                        label="Nome Fantasia"
                        placeholder="Nome Fantasia"
                        name="nomeFantasia"
                        value={client?.nomeFantasia}
                        onChange={(event) => setClient({...client, nomeFantasia: event.target.value})}
                    />
                    <Form.Input
                        fluid
                        label="Razão Social"
                        placeholder="Razão Social"
                        name="razaoSocial"
                        value={client?.razaoSocial}
                        onChange={(event) => setClient({...client, razaoSocial: event.target.value})}
                    />

                    <Form.Input
                        label="Cnpj"
                        name="cnpj"
                        type="text"
                        placeholder="00.000.000/0000-00"
                        value={maskCnpj(client?.cnpj)}
                        onChange={(event) => setClient({...client, cnpj: event.target.value})}
                        required
                        maxLength={18}
                        mask={"00.000.000/0000-00"}
                    />

                    <Table.Row>
                        <Table.HeaderCell>
                            <Form.Button content="Voltar"
                                         icon='arrow left'
                                         onClick={() => navigate('/backoffice/clients/')} grey/>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <Form.Button content="Atualizar"
                                         type={"submit"}
                                         icon='save'
                                         color={"green"}/>
                        </Table.HeaderCell>
                    </Table.Row>
                    {error && <Message negative>{error}</Message>}
                </Segment>
            </Form>
        </div>
    );
};

export default EditClientsPage;
